import { Button } from '@creditornot/cb-button';
import { cssThemedValue, elevationCss } from '@creditornot/cb-ingredients';
import { Tag } from '@creditornot/cb-tag';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import YuhoWaving from 'common/illustrations/YuhoWaving';
import { Typography } from 'common/typography';
import { openIntercom } from 'modules/intercom';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const TipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Tip = styled.div`
  ${elevationCss(12)}

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 12px;
  border-radius: 8px;
  background: ${cssThemedValue('surfaceMain')};

  &::after {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    top: 50%;
    right: -3px;
    background: inherit;
    transform-origin: center;
    transform: rotate(45deg) translateY(-50%);
  }
`;

const YuhoContainer = styled.div`
  flex: 1;
  flex-shrink: 0;
`;

const GuideContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
`;

const getBoldText = (text: string) => <strong>{text}</strong>;

const ImageCoverageGuide = () => {
  return (
    <Root>
      <TipContainer>
        <Tip>
          <Tag variant="lightGreen">
            <FormattedMessage id="insights.menu.image-coverage.section.tip.yuho-tip-title" />
          </Tag>
          <Typography.Body3>
            <FormattedMessage
              id="insights.menu.image-coverage.section.tip.yuho-tip-content"
              values={{ strong: getBoldText }}
            />
          </Typography.Body3>
        </Tip>

        <YuhoContainer>
          <YuhoWaving width="88" height="147" />
        </YuhoContainer>
      </TipContainer>

      <GuideContainer>
        <Typography.Body3>
          <FormattedMessage id="insights.menu.image-coverage.section.tip.guide-description" />
        </Typography.Body3>

        <Button size="small" variant="lightBlue" onClick={openIntercom}>
          <FormattedMessage id="insights.menu.image-coverage.section.tip.contact-support" />
        </Button>
      </GuideContainer>
    </Root>
  );
};

export default ImageCoverageGuide;
